import { Component, inject, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { environment } from './environments/environment';
import { LoaderComponent } from './shared/components/loader/loader';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, LoaderComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {

  private msal = inject(MsalService);

  protected readonly title = signal('financial-report-web');

  constructor() {
    this.msal.handleRedirectObservable().subscribe({
      next: (result) => {
        if (result) {
          this.msal.instance.setActiveAccount(result.account);
        }
      },
      error: console.error,
    });
  }
}
